import omit from 'lodash/omit'
import pickBy from 'lodash/pickBy'

import { Scope } from '../../../../../enums/scope'
import { isAuthorized } from '../../../../../utils/isAuthorized'
import { FastItem } from '../types/fastItem'
import { FastItems } from '../types/fastItems'
import { MenuNavItem } from '../types/menuNavItem'

const fastItemsScopes: Record<FastItem, Scope | Scope[] | null> = {
  newInvoice: Scope.InvoiceWrite,
  newBill: Scope.BillWrite,
  newQuote: Scope.OfferWrite,
}

interface GetFastMenuFilteredItemsOptions {
  fastItems: FastItems
  isNewBillItemDisabled?: boolean
  isUmbrellaContext?: boolean
}

export const getFastMenuFilteredItems = ({
  fastItems,
  isNewBillItemDisabled,
  isUmbrellaContext,
}: GetFastMenuFilteredItemsOptions): MenuNavItem[] => {
  if (isUmbrellaContext) {
    return []
  }

  let filteredItems = fastItems

  if (isNewBillItemDisabled) {
    filteredItems = omit(filteredItems, ['newBill'])
  }

  filteredItems = pickBy(filteredItems, (_item, key) => {
    const itemScopes = fastItemsScopes[key as FastItem]
    if (itemScopes && isAuthorized(itemScopes)) {
      return true
    }
  })

  return Object.values(filteredItems)
}
